var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 222.54 194.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3, .cls-5 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4, .cls-6, .cls-7, .cls-8 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 225,
    y1: 146.73,
    x2: 225,
    y2: 332.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffab00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 362.96,
    y1: 285.23,
    x2: 106.22,
    y2: 210.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 17.91,
    y1: 185.56,
    x2: 370.89,
    y2: 249.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 298.96,
    y1: 254.46,
    x2: 50.32,
    y2: 298.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 449.03,
    y1: 242.72,
    x2: 125.51,
    y2: 299.4,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 177.27,
    cy: 110.6,
    r: 70.18,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 190.43,
    cy: 166.43,
    r: 63.78,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fox"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M334.23,241.45l-26.36-21,14-80.14a5.41,5.41,0,0,0-8.08-5.59L258.6,167.33H191.4l-55.15-32.58a5.41,5.41,0,0,0-8.08,5.59l14,80.14-26.36,21a5.4,5.4,0,0,0,.17,8.59L221.8,327.83l.1.05a5.53,5.53,0,0,0,1.39.71l.15,0a5.42,5.42,0,0,0,1.56.25,5.36,5.36,0,0,0,1.56-.25l.15,0a5.53,5.53,0,0,0,1.39-.71l.1-.05L334.06,250a5.4,5.4,0,0,0,.17-8.59Z",
    transform: "translate(-113.73 -134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.25,134.75a5.41,5.41,0,0,0-8.08,5.59l14,80.14-26.36,21a5.4,5.4,0,0,0,.17,8.59L221.8,327.83l.1.05a5.53,5.53,0,0,0,1.39.71l.15,0a5.42,5.42,0,0,0,1.56.25L191.4,167.33Z",
    transform: "translate(-113.73 -134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.56,328.63l.15,0a5.53,5.53,0,0,0,1.39-.71l.1-.05L334.06,250a5.4,5.4,0,0,0,.17-8.59l-26.36-21,14-80.14a5.41,5.41,0,0,0-8.08-5.59L258.6,167.33,225,328.88A5.36,5.36,0,0,0,226.56,328.63Z",
    transform: "translate(-113.73 -134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M115.77,241.45a5.4,5.4,0,0,0,.17,8.59L221.8,327.83l.1.05a5.53,5.53,0,0,0,1.39.71l.15,0a5.42,5.42,0,0,0,1.56.25l-82.87-108.4Z",
    transform: "translate(-113.73 -134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.71,328.59a5.53,5.53,0,0,0,1.39-.71l.1-.05L334.06,250a5.4,5.4,0,0,0,.17-8.59l-26.36-21L225,328.88a5.36,5.36,0,0,0,1.56-.25Z",
    transform: "translate(-113.73 -134)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "111.27 194.88 147.98 31.3 144.87 33.33 111.27 194.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "111.27 194.88 194.14 86.48 197.6 89.23 111.27 194.88"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/fox.448ef57bb3edc3099f5c271af5824fca.svg";
export { ForwardRef as ReactComponent };